"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const monaco = __importStar(require("monaco-editor"));
const monaco_cut_line_scss_1 = __importDefault(require("./styles/monaco-cut-line.scss"));
function showCutLine(editor) {
    const model = editor.getModel();
    if (!model) {
        throw new Error('Cannot get model');
    }
    editor.updateOptions({
        glyphMargin: true
    });
    let decorations = [];
    const moveButton = (lineNumber) => {
        if (!lineNumber) {
            if (decorations.length) {
                decorations = editor.deltaDecorations(decorations, []);
            }
            return;
        }
        decorations = editor.deltaDecorations(decorations, [
            {
                range: new monaco.Range(lineNumber, 1, lineNumber, 1),
                options: {
                    isWholeLine: true,
                    glyphMarginHoverMessage: {
                        value: 'Cut this line'
                    },
                    glyphMarginClassName: monaco_cut_line_scss_1.default.widget
                }
            }
        ]);
    };
    editor.onDidChangeCursorPosition(e => {
        moveButton(e.position.lineNumber);
    });
    editor.onDidBlurEditorText(() => {
        moveButton(0);
    });
    editor.onMouseDown(e => {
        const { element, position, type } = e.target;
        if (!position || !element)
            return;
        const isButtonClicked = type === monaco.editor.MouseTargetType.GUTTER_GLYPH_MARGIN &&
            element.classList.contains(monaco_cut_line_scss_1.default.widget);
        if (!isButtonClicked)
            return;
        editor.trigger('monaco-cut-line', 'editor.action.clipboardCutAction', {});
    });
    return () => { };
}
exports.showCutLine = showCutLine;
